import IconCarElectricConsumptionOutline from '@adv-mt/mt-svg-icons/lib/CarElectricConsumptionOutline.js'
import IconCng from '@adv-mt/mt-svg-icons/lib/Cng.js'
import IconDiesel from '@adv-mt/mt-svg-icons/lib/Diesel.js'
import IconElectrOutline from '@adv-mt/mt-svg-icons/lib/Electroutline.js'
import IconExtras from '@adv-mt/mt-svg-icons/lib/Extras.js'
import IconGasolina from '@adv-mt/mt-svg-icons/lib/Gasolina.js'
import IconHybridPlugIn from '@adv-mt/mt-svg-icons/lib/HybridPlugIn.js'
import IconLpg from '@adv-mt/mt-svg-icons/lib/Lpg.js'

const FUEL_TYPES = {
  DIESEL: 1,
  GASOLINE: 2,
  ELECTRIC: 3,
  HYBRID: 4,
  HYBRID_PLUG_IN: 5,
  GLP: 6,
  CNG: 7,
  OTHER: 8
}

export const ICONS_BY_FUEL_TYPE = {
  [FUEL_TYPES.DIESEL]: IconDiesel,
  [FUEL_TYPES.GASOLINE]: IconGasolina,
  [FUEL_TYPES.ELECTRIC]: IconElectrOutline,
  [FUEL_TYPES.HYBRID]: IconCarElectricConsumptionOutline,
  [FUEL_TYPES.HYBRID_PLUG_IN]: IconHybridPlugIn,
  [FUEL_TYPES.GLP]: IconLpg,
  [FUEL_TYPES.CNG]: IconCng,
  [FUEL_TYPES.OTHER]: IconExtras
}
